<template>
  <div class="page-footer-wrap">
    <div class="page-footer-info clearfix">
      <div class="info-box">
        <div class="info-box-icon"><img src="@/assets/images/public/icon-footer1.png"></div>
        <div class="info-box-text">{{$t("footer.office1")}}：{{$t("footer.office2")}}</div>
      </div>
      <!-- <div class="info-box">
        <div class="info-box-icon"><img src="@/assets/images/public/icon-footer2.png"></div>
        <div class="info-box-text">传真：86-532-6609-5103</div>
      </div> -->
      <div class="info-box box-2">
        <div class="info-box-icon"><img src="@/assets/images/public/icon-footer3.png"></div>
        <div class="info-box-text">{{$t("footer.email1")}}：{{$t("footer.email2")}}</div>
      </div>
      <div class="info-box box-3">
        <div class="info-box-icon"><img src="@/assets/images/public/icon-footer4.png"></div>
        <div class="info-box-text table"><span class="table-cell" style="white-space: nowrap;">{{$t("footer.address1")}}:</span>
          <span class="table-cell tl">{{$t("footer.address2")}}<span class="m-show"></span>{{$t("footer.address3")}}</span></div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pageLayoutInfo',
  data () {
    return {

    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {

    }
  }
}
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .English .page-footer-wrap .page-footer-info {
    width: 11rem
    .info-box.box-2{width:28.66%}
    .info-box.box-3{
    padding-left: .2rem;padding-right:.2rem;width:38%
    span{display: inline}
  }
}
  .page-footer-wrap
    bottom 70px;width: 100%;min-height: 1.84rem;background-color #fff
    .page-footer-info
      margin: 0 auto;width 9.7rem;
      .info-box
        fl();width 33.33%;    padding: 0 .45rem;padding-top .45rem;padding-bottom .35rem;rela();min-height:1.83rem
        &:after
          content: '';width:1px;height:60%;background:#e5e5e5;abso();right:0;top:0.05rem;bottom:0;margin:auto
        &:last-child
          &:after
            display: none
        .info-box-icon
          margin: 0 auto;width: 40px;height: 40px;border-radius 50%;border 1px solid #cdcdcd;text-align center
        .info-box-icon img
           width 100%;height 100%;display block
        .info-box-text
          margin-top: .25rem;text-align center;font-size .14rem;color #333333
        .info-box-text2
          margin-top: .05rem;text-indent 2.5em;text-align center;font-size .14rem;color #333333

  

</style>
<style lang="stylus" scoped>
  @media screen and (max-width: 768px){
    .m-show{display:block}
    .table{padding-right:.28rem}
    .page-footer-wrap{
      .page-footer-info{
          width: 6.9rem !important; padding: .6rem 0 .5rem;
        .info-box{width:100% !important;padding:.16rem 0;line-height :.4rem;min-height:auto;
          &:after{display:none}
          .info-box-icon{width:.4rem;height:.4rem;margin:0;float :left;}
      .info-box-text{text-align:left;width:6.3rem;float :right;margin:0;font-size:.26rem;}
        }
      }
    }
    .English .page-footer-wrap .page-footer-info .info-box.box-3{padding-left: 0;padding-right: 0;}
  }
  
  </style>
